module.exports = __webpack_public_path__ + "media/src/public/img/icon-54538a6df0f7a806b22bda7dc4a7986e.svg";